import env from '@framework/env/env';

const config = {
  name: 'OrderBook',
  code: 'orderBook' as const,
  abbr: 'ORB',
  supportEmail: env('CREDENTIALS__SUPPORT__EMAIL'),
  isConsentForEDeliveryRequired: false,
};

export default config;
